import { map, switchMap } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { UserSettingsAction } from '../userSettings.action';

type IDependencies = IClientApiDependencySegment;

export const loadUserSettingsEpic: IEpic<{}, IDependencies> = (action$, _, { api }) => action$.pipe(
  isTypeOf(UserSettingsAction.load.started),
  switchMap(() =>
    api.getUserSettings().pipe(
      map(({ settings }) => UserSettingsAction.load.done({ params: undefined, result: settings })),
      catchApiError((error) => [
        UserSettingsAction.load.failed({ params: undefined, error }),
        createApiErrorNotification(error),
      ]),
    ),
  ),
);
